import { RenderContext } from '@eventbrite/checkout-fairy-api';
import { CheckoutState } from '../../state';
import { getNamespaceValue } from '../utils/selector';

export const getEventDates = (
    state: CheckoutState,
): Record<string, RenderContext['eventDates']> =>
    getNamespaceValue(state.event, 'eventDates', {});
